"use client";

import React, { useEffect, useMemo, useState } from "react";

import styles from "./circular-progress.module.scss";

const CircularProgress = ({ progress, strokeWidth = 7 }) => {
  const [progressSize, setProgressSize] = useState(90);
  const getResponsiveSize = useMemo(() => {
    const width = window.innerWidth;

    if (width <= 460) return 60;
    if (width <= 641) return 70;
    if (width <= 1025) return 80;
    return 90;
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setProgressSize(getResponsiveSize);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const radius = (progressSize - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <svg
      width={progressSize}
      height={progressSize}
      className={styles.circularProgress}
    >
      <circle
        stroke="#e0e0e0"
        fill="transparent"
        strokeWidth={strokeWidth}
        r={radius}
        cx={progressSize / 2}
        cy={progressSize / 2}
      />
      <circle
        stroke="#f3912e"
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        r={radius}
        cx={progressSize / 2}
        cy={progressSize / 2}
        transform={`rotate(-90 ${progressSize / 2} ${progressSize / 2})`}
        className={styles.progressCircle}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        className={styles.progressText}
      >
        {`${progress}%`}
      </text>
    </svg>
  );
};

export default CircularProgress;
